<template>
    <div class="content-blocks pt-no-header not-found-content-blocks">
        <div class="entry-leadText block block-text-standard block-text-lead container-fluid">
            <div class="row content-block-row">
                <div class="col-12 text-lead">
                    <template v-if="$i18n.locale == 'fr'">
                        <p class="mb-0">Une erreur s’est produite.</p>
                    </template>
                    <template v-else-if="$i18n.locale == 'en'">
                        <p class="mb-0">Something went wrong.</p>
                    </template>
                    <template v-else>
                        <p class="mb-0">Da ist etwas schiefgegangen.</p>
                    </template>
                </div>
            </div>
        </div>
        <div class="block block-text-standard container-fluid mt-0">
            <div class="row content-block-row">
                <div class="col-12 col-lg-3"><!----></div>
                <div class="col-12 col-md-9 mx-md-auto mx-lg-0 col-lg-6">
                    <template v-if="$i18n.locale == 'fr'">
                        <p>Nous n’avons pas trouvé la page. Elle n’existe peut-être pas, a été modifiée ou renommée. Saisissez le contenu souhaité dans notre <router-link :to="$tc('routePaths.search')">recherche</router-link>.</p>
                        <p>Au fait : dans notre <router-link :to="{ name: 'JournalOverview', params: {locale: $route.params.locale || ''} }">journal</router-link>, nous partageons régulièrement des aperçus de notre travail ainsi que nos apprentissages et expériences. Venez jeter un œil !</p>
                    </template>
                    <template v-else-if="$i18n.locale == 'en'">
                        <p>We couldn't find the page. Either it doesn’t exist, has been changed, or renamed. Enter the desired content in our <router-link :to="$tc('routePaths.search')">search</router-link>.</p>
                        <p>By the way: In our <router-link :to="{ name: 'JournalOverview', params: {locale: $route.params.locale || ''} }">journal</router-link> we regularly provide insights into our work and share learnings and experiences. Have a look!</p>
                    </template>
                    <template v-else>
                        <p>Wir haben die Seite nicht gefunden. Entweder existiert sie nicht, wurde verändert oder umbenannt. Geben Sie den gewünschten Inhalt in unserer <router-link :to="$tc('routePaths.search')">Suche</router-link> ein.</p>
                        <p>Übrigens: In unserem <router-link :to="{ name: 'JournalOverview', params: {locale: $route.params.locale || ''} }">Journal</router-link> geben wir regelmässig Einblicke in unsere Arbeit, teilen Learnings und Erfahrungen. Schauen Sie mal vorbei!</p>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { i18n } from '@/i18n'
export default {
  name: 'NotFound',
}
</script>
